import { render, staticRenderFns } from "./BranchNew.vue?vue&type=template&id=4593a0ac"
import script from "./BranchNew.vue?vue&type=script&lang=js"
export * from "./BranchNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports